export const SelectStyles = {
    control: (base) => ({
      ...base,
      backgroundColor: "rgb(182 182 182 / 0.25)",
      borderColor: "transparent",
      borderRadius: "4px",
      caretColor: "white",
      "&:hover": { borderColor: "transparent" }, // Borde en hover
    }),
    input: (provided) => ({
      ...provided,
      color: "#F7F5F2",
      fontWeight: "bold", // Establece el color del texto del input a blanco
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? "#F2F2F2" : "#FEFEFE",
      color: "black",
      cursor: "pointer",
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: "#FEFEFE", // Color del indicador
      "&:hover": {
        color: "#3FB2E3", // Color del indicador en hover
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#fefefe", // Establece el color del texto de la opción seleccionada a blanco
      fontWeight: "bold",
    }),
    clearIndicator: (styles) => ({
      ...styles,
      color: "black", // Aquí puedes poner el color que desees
      ":hover": {
        color: "black", // Color cuando se pasa el ratón por encima (hover)
      },
    }),
    groupHeading: (provided, state) => ({
      ...provided,
      backgroundColor: state.data.label === "Primaria" ? "#28345C" : "#6F7792",
      color: "#fefefe",
      fontSize: ".65em",
      textTransform: "uppercase",
      paddingTop: "8px",
      paddingBottom: "8px",
    }),
  };